import { fetchJSON } from "./utils";

export function fetchInteractionSurvey(interaction_id) {
    const url = `/api/survey/interaction/${interaction_id}`;
    return fetchJSON(url, null, null, "get");
}
